import { encodeCookieValue } from "./_helpers/encodeCookieValue.helper";
import { encodeCookieName } from "./_helpers/encodeCookieName.helper";
/**
 * Set a cookie with a name, value and optional attributes.
 */
export const setCookie = (name, value, attributes) => {
    const options = {
        path: "",
        domain: "",
        maxAge: undefined,
        expires: undefined,
        httpOnly: false,
        secure: false,
        ...attributes,
    }; // Changeable variables for name and value
    let cookieName = name;
    let cookieValue = value;
    // Set object with attributes
    const cookieAttributes = {
        Path: options.path,
        Domain: options.domain,
        HttpOnly: options.httpOnly,
        Secure: options.secure,
    };
    if (typeof options.maxAge === "number") {
        cookieAttributes["Max-Age"] = options.maxAge.toString();
    }
    else if (options.expires) {
        if (typeof options.expires === "number") {
            // Convert number of days into milliseconds
            cookieAttributes.Expires = new Date(Date.now() + options.expires * 864e5).toUTCString();
        }
        else {
            cookieAttributes.Expires = options.expires.toUTCString();
        }
    }
    // Turn values supplied as arrays and objects into strings
    try {
        const result = JSON.stringify(cookieValue);
        if (/^[{[]/.test(result)) {
            cookieValue = result;
        }
    }
    catch (error) {
        // Could not stringify, probably because the value was already a string
    }
    // Encode name and value
    cookieName = encodeCookieName(cookieName);
    cookieValue = encodeCookieValue(cookieValue);
    // Convert attributes to a string
    let attributesString = "";
    for (const attributeName in cookieAttributes) {
        if (Object.prototype.hasOwnProperty.call(cookieAttributes, attributeName) &&
            cookieAttributes[attributeName]) {
            // Set name
            attributesString += `; ${attributeName}`;
            // If value is a boolean, don't set a value
            if (cookieAttributes[attributeName] === true) {
                continue;
            }
            // Set value
            attributesString += `=${String(cookieAttributes[attributeName]).split(";")[0]}`;
        }
    }
    // Set cookie
    document.cookie = `${cookieName}=${cookieValue}${attributesString}`;
};
